import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "chat-message-container user"
}
const _hoisted_2 = { class: "chat-message user" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "chat-message typing"
}

import { ref, onMounted, watch, nextTick, computed, inject, onUnmounted } from "vue";
import { marked } from "marked";
import { useI18n } from "vue-i18n";
import { v4 as uuid } from "uuid";


export default /*@__PURE__*/_defineComponent({
  __name: 'AIAssistantTranscription',
  props: {
  initialContext: Object,
  transcriptionMessages: {
    type: Array,
    default: () => []
  },
  generatingTranscription: Boolean
},
  setup(__props) {

const { t, locale } = useI18n();

const props = __props;

const patient = computed(() => {
  const birthDate = props.initialContext?.patient?.birthDate;
  const age = birthDate ? new Date().getFullYear() - new Date(birthDate).getFullYear() : null;
  const initialGender = props.initialContext?.patient?.gender;
  let gender = null;
  
  if (`${initialGender}`.toLowerCase().startsWith("m")) {
    gender = t("patient.genderMale");
  } else if (`${initialGender}`.toLowerCase().startsWith("f")) {
    gender = t("patient.genderFemale");
  }
  
  return {
    ...props.initialContext?.patient,
    age,
    gender,
  };
});

const patientTitle = computed(() => {
  return [
    patient.value.name,
    patient.value.gender,
    patient.value.age ? `${patient.value.age} ${t("patient.yearsOld")}` : null,
  ]
    .filter(Boolean)
    .join(", ");
});

const isTyping = ref(false);
const showScrollButton = ref(false);
const chatBody = ref<HTMLElement | null>(null);
const actionState = ref<string | null>(null);

const scrollToBottom = () => {
  if (chatBody.value) {
    chatBody.value.scrollTop = chatBody.value.scrollHeight;
  }
};

const onScroll = () => {
  if (chatBody.value) {
    const isAtBottom = chatBody.value.scrollHeight - chatBody.value.scrollTop === chatBody.value.clientHeight;
    showScrollButton.value = !isAtBottom;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_w_spinner = _resolveComponent("w-spinner")!
  const _component_w_text = _resolveComponent("w-text")!
  const _component_w_icon_button = _resolveComponent("w-icon-button")!
  const _component_w_stack = _resolveComponent("w-stack")!

  return (_openBlock(), _createBlock(_component_w_stack, {
    id: "ai-assistant-chat",
    direction: "column",
    "align-items": "stretch",
    "full-height": ""
  }, {
    default: _withCtx(() => [
      (actionState.value !== 'review')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "chat-body",
            ref_key: "chatBody",
            ref: chatBody
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.transcriptionMessages, (message, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                message
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", { innerHTML: message }, null, 8, _hoisted_3)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (isTyping.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_w_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_w_spinner, { size: "small" })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 512))
        : _createCommentVNode("", true),
      (showScrollButton.value)
        ? (_openBlock(), _createBlock(_component_w_icon_button, {
            key: 1,
            "icon-name": "arrow-down",
            "icon-color": "secondary",
            class: "scroll-button",
            onClick: scrollToBottom,
            "aria-label": _ctx.$t('chat.scrollToBottomLabel')
          }, null, 8, ["aria-label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})